module.exports = __webpack_public_path__ + "img/icon_admission.92d4dff0.png";